import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../utils/useAuth";

const AdminProtectedRoute = ({ children }) => {
  const { isAdmin, accessToken } = useAdminAuth();

  if (!isAdmin && !accessToken) {
    return <Navigate to={"/admin/auth"} replace />;
  }

  return children;
};

export default AdminProtectedRoute;
